import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ContentSlide } from '@bn/auth/models/sliders/content-slide.model';
import { LazyLoadDirective } from '@bn/web-ui';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { LoadingComponent } from '@bn/web-ui/loading/loading.component';

@Component({
  selector: 'bn-auth-content-slider',
  templateUrl: './content-slider.component.html',
  styleUrls: ['./content-slider.component.scss'],
  imports: [NgClass, LoadingComponent, LazyLoadDirective, RouterLink, ButtonComponent],
})
export class ContentSliderComponent implements OnDestroy {
  @Input()
  public items?: ContentSlide[];

  @Input()
  public centered? = false;

  @Input()
  public width?: string;

  @Input()
  public loading = false;

  @Input()
  public slideInterval = 5000;

  public activeIndex = 0;
  public interval?: ReturnType<typeof setInterval>;
  public isMouseOver = false;

  constructor() {
    this.handleAutoSlide();
  }

  public ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  public onPaginationClick(activeIndex: number): void {
    this.activeIndex = activeIndex;
  }

  public onMouseOver(): void {
    this.isMouseOver = true;
  }

  public onMouseLeave(): void {
    this.isMouseOver = false;
  }

  private handleAutoSlide(): void {
    this.interval = setInterval(() => {
      if (!this.items?.length || this.isMouseOver) return;

      this.activeIndex = this.activeIndex === this.items?.length - 1 ? 0 : this.activeIndex + 1;
    }, this.slideInterval);
  }
}
